import { Alert, Button, Icon, Modal, Text } from '@inflearn/ds-react';
import { faEnvelope } from '@inflearn/pro-solid-svg-icons';
import { map } from 'lodash-es';
import { useTranslation } from 'react-i18next';

import { useReferUrlNavigation } from '../../hooks/useReferUrlNavigation';

interface EmailSentModalProps {
  opened: boolean;
  onClose?: () => void;
  email: string;
  title: string;
  descriptions: string[];
}

const EmailSentModal = ({
  // biome-ignore lint/suspicious/noEmptyBlockStatements: 빈 함수 블록 혀용
  onClose = () => {},
  opened,
  email,
  title,
  descriptions,
}: EmailSentModalProps) => {
  const { navigateReferUrl, navigateMainUrl } = useReferUrlNavigation();
  const { t } = useTranslation();

  return (
    <Modal.Root opened={opened} onClose={onClose} size="sm">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert
            type="default"
            radius="md"
            icon={<Icon icon={faEnvelope} />}
            title={email}
            mb={16}
          />
          <Text size="md" color="gray.7" align="center">
            {map(descriptions, (description) => {
              return (
                <>
                  {description}
                  <br />
                </>
              );
            })}
          </Text>
        </Modal.Body>
        <Modal.Footer align="grow">
          <Button size="md" variant="default" onClick={navigateReferUrl}>
            {t('이전 페이지로')}
          </Button>
          <Button size="md" variant="filled" onClick={navigateMainUrl}>
            {t('메인 페이지로')}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};

export default EmailSentModal;
